import { FaRobot } from "react-icons/fa";

/**
 * Fixed bottom-right launcher, in the same spot and style as the old AISuggestionBot's button
 * (bg-indigo-600 circle + FaRobot). z-index is inline rather than a Tailwind arbitrary-value
 * class (z-[...]) since this project's Tailwind v2 build doesn't generate those.
 */
export function AdvisorLauncherButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{ zIndex: 1000 }}
      className="fixed bottom-6 right-6 flex h-16 w-16 items-center justify-center rounded-full bg-indigo-600 text-white shadow-xl transition-colors hover:bg-indigo-700"
    >
      <FaRobot className="h-7 w-7" />
    </button>
  );
}
